export const GET_GROCERIES_REQUEST = "GET_GROCERIES_REQUEST";
export const GET_GROCERIES_SUCCESS = "GET_GROCERIES_SUCCESS";
export const GET_GROCERIES_FAILURE = "GET_GROCERIES_FAILURE";